import * as THREE from 'three'
import Experience from './Experience'
import gsap from 'gsap'
import { portfolioExperiences } from '../../data/portfolioContent.js'

export default class ExperiencesSection
{
    constructor(_options)
    {
        this.time = _options.time
        this.resources = _options.resources
        this.camera = _options.camera
        this.passes = _options.passes
        this.objects = _options.objects
        this.areas = _options.areas
        this.zones = _options.zones
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        if(this.debug)
        {
            this.debugFolder = this.debug.addFolder('experiences')
            this.debugFolder.open()
        }

        this.items = []
        this.interDistance = 12
        this.positionRandomess = 2
        this.experienceHalfWidth = 6

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false
        this.container.updateMatrix()

        this.setGeometries()
        this.setMeshes()
        this.setList()
        this.setZone()

        for(const options of this.list)
        {
            this.add(options)
        }

        // #region agent log
        fetch('http://127.0.0.1:7823/ingest/d35b8971-5abb-4ced-aa93-3de090899b87',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'0ad91f'},body:JSON.stringify({sessionId:'0ad91f',runId:'experience-direction',location:'ExperiencesSection.js:constructor',message:'experiences laid out west from mal',data:{sectionX:this.x,sectionY:this.y,direction:'-x',interDistance:this.interDistance,positions:this.items.map((item)=>({company:item.company,x:item.x,y:item.y}))},timestamp:Date.now(),hypothesisId:'H'})}).catch(()=>{});
        // #endregion
    }

    setGeometries()
    {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes()
    {
        this.meshes = {}
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
    }

    setList()
    {
        this.list = portfolioExperiences.map((experience) => ({
            company: experience.company,
            logo: experience.logo,
            title: experience.title,
            period: experience.period,
            description: experience.description,
            highlights: experience.highlights,
        }))
    }

    setZone()
    {
        const span = (this.list.length - 1) * this.interDistance
        const totalWidth = this.list.length * (this.interDistance / 2)

        const zone = this.zones.add({
            position: { x: this.x - span / 2, y: this.y },
            halfExtents: { x: totalWidth, y: 12 },
            data: { cameraAngle: 'experiences' },
        })

        zone.on('in', (_data) =>
        {
            this.camera.angle.set(_data.cameraAngle)
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: 0, duration: 2 })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: 0, duration: 2 })
        })

        zone.on('out', () =>
        {
            this.camera.angle.set('default')
            gsap.to(this.passes.horizontalBlurPass.material.uniforms.uStrength.value, { x: this.passes.horizontalBlurPass.strength, duration: 2 })
            gsap.to(this.passes.verticalBlurPass.material.uniforms.uStrength.value, { y: this.passes.verticalBlurPass.strength, duration: 2 })
        })
    }

    add(_options)
    {
        const x = this.x - this.items.length * this.interDistance
        let y = this.y

        if(this.items.length > 0)
        {
            y += (Math.random() - 0.5) * this.positionRandomess
        }

        const experience = new Experience({
            resources: this.resources,
            objects: this.objects,
            areas: this.areas,
            geometries: this.geometries,
            meshes: this.meshes,
            x,
            y,
            ..._options,
        })

        this.container.add(experience.container)

        if(this.items.length >= 1)
        {
            const previousExperience = this.items[this.items.length - 1]
            const start = new THREE.Vector2(previousExperience.x - this.experienceHalfWidth, previousExperience.y)
            const end = new THREE.Vector2(experience.x + this.experienceHalfWidth, experience.y)
            const delta = end.clone().sub(start)
            this.tiles.add({
                start,
                delta,
            })
        }

        this.items.push(experience)
    }
}
